import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "p-listbox-header" }
const _hoisted_3 = { class: "p-listbox-filter-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueInputText = _resolveComponent("PrimeVueInputText")!
  const _component_PrimeVueListBox = _resolveComponent("PrimeVueListBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading && !_ctx.fetched)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          })
        ], 64))
      : (_openBlock(), _createBlock(_component_PrimeVueListBox, {
          key: 1,
          "model-value": _ctx.modelValue,
          options: _ctx.sortedOptions,
          "option-value": "value",
          "option-label": "label",
          multiple: true,
          "list-style": "max-height: 250px;",
          class: _normalizeClass({ 'p-invalid': _ctx.invalid }),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_PrimeVueInputText, {
                  class: "p-listbox-filter",
                  modelValue: _ctx.keyword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                  placeholder: _ctx.$t('search')
                }, null, 8, ["modelValue", "placeholder"]),
                _createElementVNode("span", {
                  class: _normalizeClass(["p-listbox-filter-icon pi", _ctx.loading ? 'pi-spinner pi-spin' : 'pi-search'])
                }, null, 2)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model-value", "options", "class"]))
  ]))
}